export const usaProducts = [
  {
    id: "usa-1",
    title: "Premium Wireless Earbuds Pro X200",
    price: 49.99,
    originalPrice: 89.99,
    image: "https://public.readdy.ai/ai/img_res/21255a2c1532bd7ae16d4cc60225bf53.jpg",
    seller: "TechVision Factory",
    verified: true,
    rating: 4.8,
    reviews: 2341,
    category: "Electronics",
    badge: "Best Seller",
    stock: 500,
    warehouse: "Los Angeles, CA",
    dispatchHours: 4,
    deliveryDays: "1–2",
    commission: "12%",
  },
  {
    id: "usa-2",
    title: "Organic Cotton Oversized Hoodie",
    price: 34.99,
    originalPrice: 59.99,
    image: "https://readdy.ai/api/search-image?query=organic%20cotton%20oversized%20hoodie%20beige%20cream%20color%20folded%20clean%20white%20background%20product%20photography&width=400&height=400&seq=usa-prod2&orientation=squarish",
    seller: "GreenThread Mills",
    verified: true,
    rating: 4.6,
    reviews: 1892,
    category: "Fashion",
    badge: "Eco Friendly",
    stock: 1200,
    warehouse: "New York, NY",
    dispatchHours: 6,
    deliveryDays: "2–3",
    commission: "10%",
  },
  {
    id: "usa-3",
    title: "Smart LED Desk Lamp with USB-C",
    price: 28.99,
    originalPrice: 45.00,
    image: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20white%20minimalist%20design%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=usa-prod3&orientation=squarish",
    seller: "LightCraft Industries",
    verified: true,
    rating: 4.7,
    reviews: 987,
    category: "Home",
    badge: "New Arrival",
    stock: 800,
    warehouse: "Chicago, IL",
    dispatchHours: 3,
    deliveryDays: "1–2",
    commission: "10%",
  },
  {
    id: "usa-4",
    title: "Vitamin C Brightening Serum 30ml",
    price: 19.99,
    originalPrice: 38.00,
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20glass%20bottle%20skincare%20product%20clean%20white%20background%20minimalist%20photography&width=400&height=400&seq=usa-prod4&orientation=squarish",
    seller: "PureGlow Labs",
    verified: true,
    rating: 4.9,
    reviews: 3210,
    category: "Beauty",
    badge: "Top Rated",
    stock: 2000,
    warehouse: "Miami, FL",
    dispatchHours: 2,
    deliveryDays: "1–2",
    commission: "8%",
  },
  {
    id: "usa-5",
    title: "Stainless Steel Water Bottle 32oz",
    price: 22.99,
    originalPrice: 35.00,
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20water%20bottle%20matte%20black%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=usa-prod5&orientation=squarish",
    seller: "HydroForge Co.",
    verified: true,
    rating: 4.5,
    reviews: 1567,
    category: "Sports",
    badge: "Popular",
    stock: 3000,
    warehouse: "Houston, TX",
    dispatchHours: 5,
    deliveryDays: "2–3",
    commission: "8%",
  },
  {
    id: "usa-6",
    title: "Portable Bluetooth Speaker IPX7",
    price: 39.99,
    originalPrice: 69.99,
    image: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20cylindrical%20black%20waterproof%20clean%20white%20background%20product%20photography&width=400&height=400&seq=usa-prod6&orientation=squarish",
    seller: "SoundWave Factory",
    verified: true,
    rating: 4.7,
    reviews: 2089,
    category: "Electronics",
    badge: "Flash Sale",
    stock: 450,
    warehouse: "Seattle, WA",
    dispatchHours: 2,
    deliveryDays: "1–2",
    commission: "12%",
  },
  {
    id: "usa-7",
    title: "Bamboo Cutting Board Set (3-Pack)",
    price: 24.99,
    originalPrice: 42.00,
    image: "https://readdy.ai/api/search-image?query=bamboo%20cutting%20board%20set%20three%20sizes%20kitchen%20clean%20white%20background%20product%20photography%20minimalist&width=400&height=400&seq=usa-prod7&orientation=squarish",
    seller: "EcoKitchen Works",
    verified: true,
    rating: 4.4,
    reviews: 743,
    category: "Home",
    badge: "Eco Pick",
    stock: 1500,
    warehouse: "Portland, OR",
    dispatchHours: 8,
    deliveryDays: "2–3",
    commission: "9%",
  },
  {
    id: "usa-8",
    title: "Resistance Bands Set 5-Level",
    price: 16.99,
    originalPrice: 29.99,
    image: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20colorful%20five%20levels%20fitness%20exercise%20clean%20white%20background%20product%20photography&width=400&height=400&seq=usa-prod8&orientation=squarish",
    seller: "FitForge Manufacturing",
    verified: true,
    rating: 4.6,
    reviews: 4521,
    category: "Sports",
    badge: "Hot Deal",
    stock: 5000,
    warehouse: "Dallas, TX",
    dispatchHours: 3,
    deliveryDays: "1–2",
    commission: "8%",
  },
  {
    id: "usa-9",
    title: "Noise Cancelling Headphones Studio Pro",
    price: 129.99,
    originalPrice: 199.99,
    image: "https://readdy.ai/api/search-image?query=noise%20cancelling%20over%20ear%20headphones%20black%20studio%20professional%20clean%20white%20background%20product%20photography&width=400&height=400&seq=usa-prod9&orientation=squarish",
    seller: "TechVision Factory",
    verified: true,
    rating: 4.8,
    reviews: 1203,
    category: "Electronics",
    badge: "Just Listed",
    stock: 320,
    warehouse: "Los Angeles, CA",
    dispatchHours: 4,
    deliveryDays: "1–2",
    commission: "12%",
  },
  {
    id: "usa-10",
    title: "Ceramic Pour-Over Coffee Set",
    price: 42.99,
    originalPrice: 68.00,
    image: "https://readdy.ai/api/search-image?query=ceramic%20pour%20over%20coffee%20dripper%20set%20matte%20white%20minimalist%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=usa-prod10&orientation=squarish",
    seller: "CraftKitchen Co.",
    verified: true,
    rating: 4.7,
    reviews: 892,
    category: "Home",
    badge: "New Arrival",
    stock: 600,
    warehouse: "Chicago, IL",
    dispatchHours: 6,
    deliveryDays: "2–3",
    commission: "9%",
  },
  {
    id: "usa-11",
    title: "Merino Wool Beanie — 6 Colors",
    price: 18.99,
    originalPrice: 32.00,
    image: "https://readdy.ai/api/search-image?query=merino%20wool%20beanie%20hat%20soft%20knit%20neutral%20color%20clean%20white%20background%20product%20photography%20minimalist&width=400&height=400&seq=usa-prod11&orientation=squarish",
    seller: "GreenThread Mills",
    verified: true,
    rating: 4.5,
    reviews: 634,
    category: "Fashion",
    badge: "New Arrival",
    stock: 900,
    warehouse: "New York, NY",
    dispatchHours: 5,
    deliveryDays: "2–3",
    commission: "10%",
  },
  {
    id: "usa-12",
    title: "Collagen Peptide Powder 500g",
    price: 34.99,
    originalPrice: 55.00,
    image: "https://readdy.ai/api/search-image?query=collagen%20peptide%20powder%20supplement%20white%20jar%20clean%20white%20background%20product%20photography%20minimalist%20studio&width=400&height=400&seq=usa-prod12&orientation=squarish",
    seller: "PureGlow Labs",
    verified: true,
    rating: 4.8,
    reviews: 1120,
    category: "Beauty",
    badge: "Just Listed",
    stock: 1800,
    warehouse: "Miami, FL",
    dispatchHours: 2,
    deliveryDays: "1–2",
    commission: "8%",
  },
  {
    id: "usa-13",
    title: "Adjustable Dumbbell Set 5–52 lbs",
    price: 189.99,
    originalPrice: 280.00,
    image: "https://readdy.ai/api/search-image?query=adjustable%20dumbbell%20set%20modern%20black%20clean%20white%20background%20product%20photography%20studio%20fitness%20equipment&width=400&height=400&seq=usa-prod13&orientation=squarish",
    seller: "FitForge Manufacturing",
    verified: true,
    rating: 4.9,
    reviews: 2890,
    category: "Sports",
    badge: "Best Seller",
    stock: 200,
    warehouse: "Dallas, TX",
    dispatchHours: 6,
    deliveryDays: "2–3",
    commission: "8%",
  },
  {
    id: "usa-14",
    title: "Silk Pillowcase Set — Queen Size",
    price: 29.99,
    originalPrice: 52.00,
    image: "https://readdy.ai/api/search-image?query=silk%20pillowcase%20set%20ivory%20white%20luxury%20bedroom%20clean%20white%20background%20product%20photography%20minimalist&width=400&height=400&seq=usa-prod14&orientation=squarish",
    seller: "LuxeSleep Co.",
    verified: true,
    rating: 4.7,
    reviews: 1456,
    category: "Home",
    badge: "Top Rated",
    stock: 700,
    warehouse: "Phoenix, AZ",
    dispatchHours: 4,
    deliveryDays: "1–2",
    commission: "10%",
  },
  {
    id: "usa-15",
    title: "Retinol Night Cream 50ml",
    price: 24.99,
    originalPrice: 44.00,
    image: "https://readdy.ai/api/search-image?query=retinol%20night%20cream%20jar%20luxury%20skincare%20product%20clean%20white%20background%20minimalist%20photography%20studio&width=400&height=400&seq=usa-prod15&orientation=squarish",
    seller: "PureGlow Labs",
    verified: true,
    rating: 4.6,
    reviews: 987,
    category: "Beauty",
    badge: "Popular",
    stock: 1200,
    warehouse: "Miami, FL",
    dispatchHours: 3,
    deliveryDays: "1–2",
    commission: "8%",
  },
  {
    id: "usa-16",
    title: "Running Shoes Ultra Boost X",
    price: 79.99,
    originalPrice: 129.99,
    image: "https://readdy.ai/api/search-image?query=running%20shoes%20modern%20athletic%20white%20clean%20product%20photography%20studio%20white%20background%20minimalist&width=400&height=400&seq=usa-prod16&orientation=squarish",
    seller: "StridePro Factory",
    verified: true,
    rating: 4.7,
    reviews: 3421,
    category: "Sports",
    badge: "Hot Deal",
    stock: 800,
    warehouse: "Atlanta, GA",
    dispatchHours: 5,
    deliveryDays: "2–3",
    commission: "9%",
  },
  {
    id: "usa-17",
    title: "Linen Button-Down Shirt — 5 Colors",
    price: 27.99,
    originalPrice: 48.00,
    image: "https://readdy.ai/api/search-image?query=linen%20button%20down%20shirt%20light%20beige%20minimalist%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=usa-prod17&orientation=squarish",
    seller: "GreenThread Mills",
    verified: true,
    rating: 4.5,
    reviews: 782,
    category: "Fashion",
    badge: "Eco Friendly",
    stock: 1100,
    warehouse: "New York, NY",
    dispatchHours: 6,
    deliveryDays: "2–3",
    commission: "10%",
  },
  {
    id: "usa-18",
    title: "Smart Home Security Camera 4K",
    price: 59.99,
    originalPrice: 99.99,
    image: "https://readdy.ai/api/search-image?query=smart%20home%20security%20camera%20compact%20white%20modern%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=usa-prod18&orientation=squarish",
    seller: "TechVision Factory",
    verified: true,
    rating: 4.6,
    reviews: 1678,
    category: "Electronics",
    badge: "Flash Sale",
    stock: 380,
    warehouse: "Los Angeles, CA",
    dispatchHours: 3,
    deliveryDays: "1–2",
    commission: "12%",
  },
];

export const usaCategories = [
  { id: "All", label: "All", icon: "ri-apps-line", count: 18 },
  { id: "Electronics", label: "Electronics", icon: "ri-smartphone-line", count: 4 },
  { id: "Fashion", label: "Fashion", icon: "ri-t-shirt-line", count: 3 },
  { id: "Home", label: "Home", icon: "ri-home-line", count: 4 },
  { id: "Beauty", label: "Beauty", icon: "ri-heart-line", count: 3 },
  { id: "Sports", label: "Sports", icon: "ri-run-line", count: 4 },
];

export const usaSortOptions = [
  { id: "featured", label: "Featured" },
  { id: "price-low", label: "Price: Low to High" },
  { id: "price-high", label: "Price: High to Low" },
  { id: "rating", label: "Top Rated" },
  { id: "newest", label: "Newest First" },
  { id: "dispatch", label: "Fastest Dispatch" },
];
